import React from 'react';
import { Box, Typography, Container, IconButton } from '@mui/material';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TwitterIcon from '@mui/icons-material/Twitter';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { profile } from '../content';

const socialIcon = (label: string) => {
  switch (label) {
    case 'GitHub':
      return <GitHubIcon sx={{ fontSize: '1.1rem' }} />;
    case 'LinkedIn':
      return <LinkedInIcon sx={{ fontSize: '1.1rem' }} />;
    case 'Twitter':
      return <TwitterIcon sx={{ fontSize: '1.1rem' }} />;
    default:
      return <GitHubIcon sx={{ fontSize: '1.1rem' }} />;
  }
};

const Footer: React.FC = () => (
  <Box component="footer" sx={{ py: 6, borderTop: (t) => `1px solid ${t.palette.divider}`, position: 'relative' }}>
    <Container maxWidth="lg" sx={{ px: { xs: 3, md: 6 } }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 3,
        }}
      >
        <Typography
          component="button"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          sx={{
            fontFamily: (t) => t.typography.button.fontFamily,
            fontWeight: 600,
            letterSpacing: '0.08em',
            color: 'text.primary',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            p: 0,
            '& span': { color: 'primary.main' },
          }}
        >
          {profile.wordmark}
          <span>.</span>
        </Typography>

        <Box sx={{ display: 'flex', gap: 0.5 }}>
          {profile.socials.map((s) => (
            <IconButton
              key={s.label}
              href={s.url}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={s.label}
              sx={{ color: 'text.secondary', '&:hover': { color: 'primary.main' }, transition: 'color 0.25s ease' }}
            >
              {socialIcon(s.label)}
            </IconButton>
          ))}
          <IconButton
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            aria-label="Back to top"
            sx={{
              ml: 1,
              color: 'text.secondary',
              border: (t) => `1px solid ${t.palette.divider}`,
              borderRadius: 1.5,
              '&:hover': { color: 'primary.main', borderColor: (t) => `${t.palette.primary.main}66` },
              transition: 'all 0.25s ease',
            }}
          >
            <ArrowUpwardIcon sx={{ fontSize: '1.1rem' }} />
          </IconButton>
        </Box>
      </Box>

      <Typography
        sx={{
          mt: 4,
          fontFamily: (t) => t.typography.button.fontFamily,
          fontSize: '0.72rem',
          color: 'text.disabled',
          textAlign: { xs: 'center', md: 'left' },
        }}
      >
        © {new Date().getFullYear()} {profile.name} · Built with React & TypeScript
      </Typography>
    </Container>
  </Box>
);

export default Footer;
